module.exports = __webpack_public_path__ + "static/media/bannerunete.394c6798.jpg";